module.exports = __webpack_public_path__ + "static/media/byner.1c680972.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/byner.webp
// module id = 230
// module chunks = 0